import React from "react";
import { PageHeader } from "antd";
import { ShoppingOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import ItemForm from "./form";

export default function ItemCreate() {
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Items", path: "/billing/items" },
          { label: "Create", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <ShoppingOutlined /> }}
        title="Add Item"
        style={{ marginBottom: 16 }}
      />
      <ItemForm />
    </div>
  );
}
